const style = {
  container: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
  },
  header: {
    marginBottom: "40px",
  },
  title: {
    fontSize: "32px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: "#8B949E",
    margin: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  formSection: {
    backgroundColor: "rgba(22, 27, 34, 0.5)",
    border: "1px solid #30363D",
    borderRadius: "12px",
    padding: "24px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: "0 0 24px 0",
    paddingBottom: "12px",
    borderBottom: "1px solid #30363D",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#8B949E",
  },
  input: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "8px",
    boxSizing: "border-box",
    padding: "12px 16px",
    fontSize: "16px",
    color: "#E6EDF3",
    outline: "none",
    transition: "border-color 0.2s ease, background-color 0.2s ease",
  },
  // NOVO ESTILO PARA TEXTAREA
  textarea: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "8px",
    boxSizing: "border-box",
    padding: "12px 16px",
    fontSize: "16px",
    color: "#E6EDF3",
    outline: "none",
    transition: "border-color 0.2s ease, background-color 0.2s ease",
    fontFamily: "inherit", // Garante a mesma fonte dos inputs
    minHeight: "120px",
    resize: "vertical",
  },
  inputLoading: {
    backgroundColor: "#1C2128",
    cursor: "wait",
  },
  inputGrid2Cols: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
  },
  inputGrid3Cols: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "20px",
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#8B949E",
    border: "1px solid #30363D",
    borderRadius: "8px",
    padding: "12px 20px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    transition: "background-color 0.2s ease",
  },
  submitButton: {
    backgroundColor: "#58A6FF",
    color: "#0D1117",
    border: "none",
    borderRadius: "8px",
    padding: "12px 20px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    transition: "opacity 0.2s ease",
  },
};
export default style;
